var map = {
	"./corn_leaf.fbx": 7270,
	"./cotton_leaf.fbx": 4473,
	"./cucumber_leaf.fbx": 9146,
	"./lettuce_leaf.fbx": 9165,
	"./peanut_leaf.fbx": 1383,
	"./potato_leaf.fbx": 7365,
	"./road_sign.fbx": 1649,
	"./soy_leaf.fbx": 2916,
	"./tomato_leaf.fbx": 3455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4104;